module.exports = __webpack_public_path__ + "virada-turno-dark.png?bfbcc7684ebf5256ff307c697d130f75";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/point/virada-turno-dark.png
// module id = 934
// module chunks = 0